import React from 'react';

import Show from 'components/Show';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useDocumentCreateStore } from 'store/document/useDocumentCreateStore';

const Grade = ({ isSelected, grade }) => {
	// Use document's creation store
	const [onAddGrade, onRemoveGrade] = useDocumentCreateStore(state => [
		state.onAddGrade,
		state.onRemoveGrade
	]);

	// Handle grade addition for document
	const onAdd = () => onAddGrade(grade);

	// Handle grade removal for document
	const onRemove = () => onRemoveGrade(grade.id);

	return (
		<div className="py-3 px-4 flex items-center space-x-2 border rounded-lg dark:border-neutral-700 transition-colors">
			<Title
				title={grade.title}
				subtitle={grade.program?.title}
				className="flex-1"
			/>

			<Button
				small
				square
				icon="link"
				to={`/grades/${grade.id}`}
			/>

			{/* Grade removal if is in selected list */}
			<Show if={isSelected}>
				<Button
					small
					square
					icon="close"
					theme="danger"
					onClick={onRemove}
				/>
			</Show>

			{/* Grade addition if is in modal list */}
			<Show if={!isSelected}>
				<Button
					small
					square
					icon="add"
					theme="success"
					onClick={onAdd}
				/>
			</Show>
		</div>
	);
};

export default Grade;